export const ConfigServicios = {
   barraBusqueda: {
      criterios: ["Nombre Servicio"],
      criteriosKeys: ["nombre"],
      criterioPrincipal: "Nombre Servicio",
   },
   table: {
      title: "Servicios",
      add: "Carga Servicio",
      options: [
         {
            name: "Importar",
            active: true,
            class: "ft-upload",
         },
         {
            name: "Exportar",
            active: true,
            class: "ft-download",
         },
         {
            name: "Solicitar Soporte",
            active: true,
            class: "ft-shuffle",
         },
      ],
   },
};
